import Box from '@material-ui/core/Box';
import styled from 'styled-components';
import type { FunctionComponent } from 'react';

interface JerryFooterProps {
  className?: string;
}

/**
 * Page footer used in signup flow providing information about Jerry company
 */
const UnstyledJerryFooter: FunctionComponent<JerryFooterProps> = ({ className }) => {
  return (
    <Box className={className}>
      <Box>
        JERRY INSURANCE AGENCY is a{' '}
        <a href="/insurance-licenses/" rel="noopener noreferrer" target="_blank" className="footer-license-link">
          licensed
        </a>{' '}
        insurance broker in 50 states and Washington D.C. (CA license #: 0M34848).
      </Box>
      <Box>Copyrights &copy; Jerry 2025. All rights reserved.</Box>
    </Box>
  );
};

export const JerryFooter = styled(UnstyledJerryFooter)`
  .footer-license-link {
    text-decoration: none;
    color: ${({ theme }) => theme.color.PrimaryDefault};
    :hover {
      text-decoration: underline;
    }
  }
`;
